import React from 'react'

const Footer = () => {
  return (
    <>
    <footer className='bg-dark text-center py-1 text-white'>arshad © all rights are reserved</footer>
      
    </>
  )
}

export default Footer
